import React from "react";
import { Field } from "formik";

export const CrownPav = ({language,formik}) => {
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const validValue = value.match(/^\d*\.?\d{0,2}$/);
        if (validValue) {
          formik.setFieldValue(name, value);
        }
      };
    return (
        <>
            <div className="row mt-5 pb-10 border-bottom">
                {/* <div className="col-lg-2">
                    <p className="font-size-lg font-weight-bold mb-0">{language.DETAIL_CROWN}</p>
                </div> */}
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-md-3 d-flex align-items-end">
                            <div className="form-group mb-0 w-100 mr-2">
                                <label className="text-uppercase">Crown Height</label>
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Min_Crown_Height_Prc"
                                        id="Min_Crown_Height_Prc"
                                        placeholder="Min"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                            <div className="form-group mb-0 w-100">
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Max_Crown_Height_Prc"
                                        id="Max_Crown_Height_Prc"
                                        placeholder="Max"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-end">
                            <div className="form-group mb-0 w-100 mr-2">
                                <label className="text-uppercase">Crown Angle</label>
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Min_Crown_Angle_Prc"
                                        id="Min_Crown_Angle_Prc"
                                        placeholder="Min"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                            <div className="form-group mb-0 w-100">
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Max_Crown_Angle_Prc"
                                        id="Max_Crown_Angle_Prc"
                                        placeholder="Max"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-end">
                            <div className="form-group mb-0 w-100 mr-2">
                                <label className="text-uppercase">Pavilion Height</label>
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Min_Pavilion_Height_Prc"
                                        id="Min_Pavilion_Height_Prc"
                                        placeholder="Min"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                            <div className="form-group mb-0 w-100">
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Max_Pavilion_Height_Prc"
                                        id="Max_Pavilion_Height_Prc"
                                        placeholder="Max"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-end">
                            <div className="form-group mb-0 w-100 mr-2">
                                <label className="text-uppercase">Pavilion Angle</label>
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Min_Pavilion_Angle_Prc"
                                        id="Min_Pavilion_Angle_Prc"
                                        placeholder="Min"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                            <div className="form-group mb-0 w-100">
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Max_Pavilion_Angle_Prc"
                                        id="Max_Pavilion_Angle_Prc"
                                        placeholder="Max"
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="input-group-append"><span className="input-group-text">%</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
